import { Country } from '@40seas/entities/common';
import { Address } from '@40seas/models';
import { countryDisplayNamesEN } from './locales/country.display-names.en';

export const GENERIC_POSTAL_CODE_REGEX = /^[A-Z0-9](?:(?![-\s]{2})[A-Z0-9\-\s]){0,10}[A-Z0-9]$/i;

export const addressProvider = {
    getCountryDisplayNameByLocale: (locale: 'en') => {
        const localeToCountryDisplayNames = {
            en: countryDisplayNamesEN,
        };

        const countryDisplayNames = localeToCountryDisplayNames[locale];

        if (!countryDisplayNames) {
            throw new Error(`Unsupported locale: ${locale}`);
        }

        return {
            of: (countryCode: string) => {
                return countryDisplayNames[countryCode];
            },
        };
    },
    makeString: (address?: Address): string => {
        if (!address) return '';

        return [
            address.addressLine1,
            address.city,
            address.state,
            address.zipCode,
            address.country ? countryDisplayNamesEN[address.country] : undefined,
        ]
            .filter(Boolean)
            .join(', ');
    },
    isValidZipCode: (country?: Country, postCode?: string): boolean => {
        if (!postCode) return false;

        if (country === Country.UNITED_KINGDOM) {
            const postCodeRegex = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i;
            return postCodeRegex.test(postCode);
        }

        return GENERIC_POSTAL_CODE_REGEX.test(postCode);
    },
};
